import React from "react";
import { FormattedMessage } from "react-intl";
import { Link } from "react-router";
export default function AuthorizedPerson({ children, inModal }) {
    return (<div>
			{inModal && (<div className="vr vr_x5">
					<h1 className="hdg">
						<FormattedMessage id="authIndividualAdd.header" defaultMessage="Authorized Person Information"/>
					</h1>
				</div>)}
			<div className="vr vr_x5">
				<div className="text">
					<FormattedMessage tagName="p" id="authIndividualAdd.intro" defaultMessage={"Oops! The name you provided does not match our record of authorized individuals. "
        + "Please select your name from the following list."}/>
				</div>
			</div>
			<div className="vr vr_x5">
				<div className={inModal ? "sides sides_x4S" : undefined}>
					{children}
				</div>
			</div>
			<div className="vr vr_x5">
				<div className="text">
					<FormattedMessage tagName="p" id="authIndividualAdd.contact" defaultMessage={"If your name is not on this list, and you believe that you are authorized, "
        + "please {link}"} values={{
        link: (<Link className="link" to="/secured/contact">
									<FormattedMessage id="authIndividualAdd.contact.link" defaultMessage="contact us."/>
								</Link>)
    }}/>
				</div>
			</div>
		</div>);
}
AuthorizedPerson.defaultProps = {
    showHeading: true
};



// WEBPACK FOOTER //
// ./src/assets/scripts/components/containers/public/Registration/AuthorizedPerson/AuthorizedPerson.tsx